import React from "react";
import axios from "axios";
//import { Button } from "antd";
import { Grid ,Form, Input, TextArea, Button, Select , Divider,Header,Icon ,Segment} from "semantic-ui-react";
import "antd/dist/antd.css";
import "../sidemenu.css";
import "../report.css";
import { API_BASE_URL } from "../utils/endpoints";
import { reactLocalStorage } from "reactjs-localstorage";
import "react-notifications-component/dist/theme.css";
import "semantic-ui-css/semantic.min.css";
import "@brainhubeu/react-carousel/lib/style.css";
import i18n from "../i18n";
import { connect } from "react-redux";
import Menutest from "./menu.js";
import { SemanticToastContainer, toast } from "react-semantic-toasts";
import "react-semantic-toasts/styles/react-semantic-alert.css";
import { Link } from "react-router-dom";
import { selectedlanguage } from "../actions";
import Modal from "react-modal";
import BackgroundArabic from '../pictures/HedarArabic.png'
import BackgroundEnglish from '../pictures/HedarEnglish.png'
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)"
  }
};

class Profile extends React.Component {
  constructor() {
    super();

    this.state = {
      firstname: "",
      lastname: "",
      email: "",
      mobile_number: "",
      land_line: "",
      account_expiration: "",
      role_name: "",
      status: "",
      weight: 0,
      sender_ids: [],
      old_password: "",
      new_password: "",
      re_passowrd: "",
      lng: "en",
      user_name: "",
    };

  }


  componentDidMount() {
    reactLocalStorage.get("authenticated");
    reactLocalStorage.get("accessToken");
    this.setState({ modalIsOpen: true });
    var lang = i18n.language;
    if (lang === "ar") {
      this.setState({isArabic:true})
      document.querySelector(".main_div_loading").style = "direction:rtl";
//      document.querySelector(".menu_header").style = "margin-right:14%";
      document.querySelector(".ant-menu").style = "text-align:right";
      document.querySelector(".blue_color").style =
      "direction: rtl;float: right;";
        document.querySelector(".fixed_profile").style = "margin-right: 0% !important;";
    }

    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/user/loadbytokken";
    } else {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/user/loadbytokken";
    }

    var headers = { "Content-Type": "application/json", tokken: token };
    axios.get(apiBaseUrl, { headers: headers }).then(res => {
      if (res.data.result.ErrorResutl) {
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: res.data.result.ErrorResutl,
          animation: "bounce",
          time: 5000
        });
        window.location = "/app";
      } else {
        this.setState({
          firstname: res.data.result.firstName,
          lastname: res.data.result.lastName,
          email: res.data.result.email,
          user_name: res.data.result.userName,
          mobile_number: res.data.result.mobile_number,
          land_line: res.data.result.land_line,
          account_expiration: res.data.result.account_expiration,
          status: res.data.result.status,
          weight: res.data.result.weight,
          sender_ids: res.data.result.sender_ids
        });
        reactLocalStorage.set("user_id_login", res.data.result.id);

        reactLocalStorage.set(
          "user_name",
          res.data.result.firstName + " " + res.data.result.lastName
        );
        reactLocalStorage.set("user_email", res.data.result.email);
        reactLocalStorage.set("user_phone", res.data.result.mobile_number);
      }
    });
    reactLocalStorage.get("user_id_login");
    var lang = i18n.language;
    if (lang === "ar") {
      
   
      document.querySelector(".blue_color").style =
        "text-align:right;width: 20%;white-space: pre;";
      //document.querySelector(".profile_add_card").style = "text-align:right";
    }
  }
  changeOldEmail = event => {
    this.setState({ email: event.target.value });
  };
  changeOldPassword = event => {
    this.setState({ old_password: event.target.value });
  };
  changeNewPassword = event => {
    this.setState({ new_password: event.target.value });
  };
  changeRePassword = event => {
    this.setState({ re_passowrd: event.target.value });
  };

  changeMobile = event => {
    this.setState({ mobile_number: event.target.value });
  };
  changeLand = event => {
    this.setState({ land_line: event.target.value });
  };
  submitForm1 = event => {
    const pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    const result = pattern.test(this.state.email);
    if(result===true){
      event.preventDefault();
    const user = {
      firstName: this.state.firstname,
      lastName: this.state.lastname,
      email: this.state.email,
      userName: this.state.user_name,
      mobile_number: this.state.mobile_number,
      land_line: this.state.land_line,
      account_expiration: this.state.account_expiration,
      status: this.state.status,
      weight: this.state.weight,
      role_name: reactLocalStorage.get("role"),
      sender_ids: JSON.stringify(this.state.sender_ids)
    };

    var data = user;
    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/user/" +
        reactLocalStorage.get("user_id_login") +
        "/updateUser";
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/user/" +
        reactLocalStorage.get("user_id_login") +
        "/updateUser";
    }

    var headers = {
      "Content-Type": "application/json",
      tokken: token
    };
    axios
      .post(apiBaseUrl, data, { headers: headers })
      .then(function(response) {
        if (response.status === 200) {
          if (response.data.status === "success") {
            toast({
              type: "success",
              title: i18n.t("success.label"),
              description: response.data.result.Description,
              animation: "bounce",
              time: 5000
            });
          } else {
            toast({
              type: "error",
              title: i18n.t("error.label"),
              description: response.data.result.ErrorDescription,
              animation: "bounce",
              time: 5000
            });
          }
        } else if (response.status === 204) {
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: "Something wrong",
            animation: "bounce",
            time: 5000
          });
        } /* else {
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: "Something wrong",
            animation: "bounce",
            time: 5000
          });
        } */
      })
      .catch(function(error) {
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: error,
          animation: "bounce",
          time: 5000
        });
      });
    }
      else{
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: !this.state.isArabic? 'Please insert valid email' :'الرجاء إدخال بريد إلكتروني صحيح' ,
          animation: "bounce",
          time: 5000
        });
      }
   
  };

  SubmitPassword = event => {
    event.preventDefault();
    var x=this;
    if (
      this.state.new_password.length === 0 ||
      this.state.re_passowrd.length === 0 ||
      this.state.old_password.length === 0
    ) {
      toast({
        type: "error",
        title: i18n.t("error.label"),
        description: i18n.t("Please_fill_all_fields.label"),
        animation: "bounce",
        time: 5000
      });
    }  else {
      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/auth/resetpassword";
      } else {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/auth/resetpassword";
      }
      var data = {};
      var headers = {
        "content-type": "application/json",
        username: this.state.user_name,
        old_password: this.state.old_password,
        new_password: this.state.new_password
      };
      axios
        .post(apiBaseUrl, data, { headers: headers })
        .then(function(response) {
          if (response.status === 200) {
            if (response.data.status === "success") {
              if (response.data.result.message) {
                toast({
                  type: "success",
                  title: i18n.t("success.label"),
                  description: response.data.result.message,
                  animation: "bounce",
                  time: 5000
                });
                window.location = "/app/";
              }
            }
            if(response.data.status === "failed")
            {
              toast({
                type: "failed",
                title: i18n.t("failed.label"),
                description: response.data.result.errorReposne,
                animation: "bounce",
                time: 5000
              });
              if(response.data.result.errorReposne == 'Password does not meet complexity requirements or contains username')
              {
                document.querySelector(".modalIsOpenError").style = "display:block";
                document.querySelector(".fixed_header").style = "z-index:9";
              }
            }
          } else if (response.status === 204 ) {
            console.log("Something wrong");
            toast({
              type: 'error',
              title: i18n.t('error.label'),
              description:i18n.t('Something_wrong.label'),
              animation: 'bounce',
              time: 5000,
  
          });
          } else {
            console.log("Something wrong");
            toast({
              type: 'error',
              title: i18n.t('error.label'),
              description:i18n.t('Something_wrong.label'),
              animation: 'bounce',
              time: 5000,
  
          });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  };
  back = () => {
    window.location = "dashboard";
  };

  render() {
    return (
      <div className="big_div">
        <Menutest />
        <div className="actionMenu" >
          <Grid columns={2} divided className="fixed_profile">
            <Grid.Row stretched className='fixed_header'>
              <Grid.Column className="grid_logo ">
              
                <Segment>
                      <h3 className="text_style blue_color">
                        {reactLocalStorage.get("lang")==="ar"?(
                      <img
                        src={require("../pictures/ArabicHedar.png")}
                        style={{width:'100% !important',height:'117px',marginTop:'8px',marginRight:'-13px'}}
                       className="himage"
                      />
                        ):(<img
                          src={require("../pictures/EnglishHedar.png")}
                          style={{width:'100% !important',height:'117px',marginLeft:'-13px',marginTop:'8px'}}
                         className="himage"
                        />)}
                      </h3>
                    </Segment>
              </Grid.Column>
            </Grid.Row>
          </Grid>
         
          <br></br><br></br><br></br><br></br>
      <div className="container_cards"  style={{paddingRight:this.state.isArabic? '':'20px'}}>

      <div className={this.state.isArabic? 'content_reportarabic' :'content_report'}>
      <br></br>
        <Segment color='black' style={{padding:'20px', minHeight:'200px'}} >
              <Form style={{padding:'20px'}}>
              <Divider horizontal>
                  <Header as='h2' color='black'  >
                    <Icon name='user circle'  color='black'/>
                    {reactLocalStorage.get('lang')==='ar' ? 'الملف الشخصي':'Profile Information' }
                
                    
                  </Header>
                </Divider>
                <br></br>
                <Form.Group widths='equal'  style={{ textAlign: reactLocalStorage.get('lang')==='ar'  ? "right" : "left"}} >    
                  <Form.Input label={i18n.t("User_name.label")}  
                    value={this.state.user_name}  style={{ textAlign: reactLocalStorage.get('lang')==='ar'  ? "right" : "left"}}   />

                  <Form.Input label={i18n.t("First_Name.label")} 
                    value={this.state.firstname} style={{ textAlign: reactLocalStorage.get('lang')==='ar'  ? "right" : "left"}} />
                  
                  <Form.Input label={i18n.t("Family_Name.label")} 
                    value={this.state.lastname} style={{ textAlign: reactLocalStorage.get('lang')==='ar'  ? "right" : "left"}} />
                
                </Form.Group>
                
                <Form.Group widths='equal' style={{ textAlign: reactLocalStorage.get('lang')==='ar'  ? "right" : "left"}}>

                  
                  <Form.Input label={i18n.t("Mobile_Number.label")}  
                    defaultValue={this.state.mobile_number}   onChange={this.changeMobile} style={{ textAlign: reactLocalStorage.get('lang')==='ar'  ? "right" : "left"}}/>
                 {/*  
                  <Form.Input label={i18n.t("account_expiration.label")}  
                    value={this.state.account_expiration}   style={{ textAlign: reactLocalStorage.get('lang')==='ar'  ? "right" : "left"}} /> */}
                  
                  <Form.Input label= {i18n.t("landline.label")} 
                    defaultValue={this.state.land_line}  onChange={this.changeLand} style={{ textAlign: reactLocalStorage.get('lang')==='ar'  ? "right" : "left"}} />
                </Form.Group>
              
                
                <Form.Group widths='equal'  style={{ textAlign: reactLocalStorage.get('lang')==='ar'  ? "right" : "left"}} > 
                 <Form.Input label={i18n.t("Email.label")} 
                    defaultValue={this.state.email}  onChange={this.changeOldEmail} style={{ textAlign: reactLocalStorage.get('lang')==='ar'  ? "right" : "left"}} />
                  </Form.Group>
                <Button content={i18n.t("Submit.label")} basic onClick={this.submitForm1} floated={reactLocalStorage.get('lang')==='ar'?'right' :' left'} />
                  <br></br> <br></br>
                  
                  <Divider horizontal>
                  <Header as='h3'> <Icon name='unlock alternate' color="black" />  {reactLocalStorage.get('lang')==='ar' ? 'إعادة تعيين كلمة المرور':'Change Password' } </Header>
                  </Divider>
                <br></br>
                  <div className="modalIsOpenError" style={{display:'none'}}>
                  <Segment inverted color='red' tertiary>
                    Password must contain [Captial Letter, Small Letter, Numbers, Special Character, Length More Than 8 Digit,Does Not Contain Username ]
                  </Segment>
                        

              </div>

              <br/>
              <Form.Group widths='equal'  style={{ textAlign: reactLocalStorage.get('lang')==='ar'  ? "right" : "left"}}  > 
                  <Form.Input label={i18n.t("Old_Password.label")}  
                      onChange={this.changeOldPassword}
                      type="password"
                      id="defaultFormCardNameEx"
                      name="old_password"
                      width={6}
                        />

                  <Form.Input label= {i18n.t("New_Password.label")}
                  onChange={this.changeNewPassword}
                  type="password"
                  id="defaultFormCardNameEx"
                  name="new_password" width={6}/>

                  <Form.Input label={i18n.t("Re_type_Password.label")} 
                  onChange={this.changeRePassword}
                  type="password"
                  id="defaultFormCardNameEx"
                  name="re_passowrd"
                  width={6}/>
              </Form.Group>

                  <Button content={i18n.t("Submit.label")} basic onClick={this.SubmitPassword} floated={reactLocalStorage.get('lang')==='ar'?'right' :' left'}/>
                  <br></br>
                  <br></br>
                
              </Form>
              </Segment>
      </div>
                
                <SemanticToastContainer />
          
              </div>
            </div>
          </div>
        );
      }
      }
      const mapStateToProps = state => {
      return { ...state };
      };
      export default connect(
      mapStateToProps,
      { selectedlanguage }
      )(Profile);
